/* <rn-video> — muted inline video that plays while in view.
   Pause/play button for WCAG 2.2.2; never autoplays with prefers-reduced-motion. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');


  class RnVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('[data-video-toggle]');
      if (!this.video) return;
      this.userPaused = reduceMotion.matches;
      this.video.muted = true;
      this.video.playsInline = true;

      // The poster arrives as data-poster so it doesn't download with the page; set it once the video is near.
      // scrollMargin reaches into the gallery's sideways scroller too (browsers without it wait until it's in view).
      if (this.video.dataset.poster) {
        const near = new IntersectionObserver(
          ([entry]) => {
            if (!entry.isIntersecting) return;
            this.video.poster = this.video.dataset.poster;
            near.disconnect();
          },
          { rootMargin: '600px', scrollMargin: '600px' }
        );
        near.observe(this);
      }

      this.toggle?.addEventListener('click', (e) => {
        e.stopPropagation();
        if (this.video.paused) {
          this.userPaused = false;
          this.play();
        } else {
          this.userPaused = true;
          this.pause();
        }
      });

      new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && !this.userPaused) this.play();
          else this.pause();
        },
        { threshold: 0.5 }
      ).observe(this);
    }

    play() {
      this.video.preload = 'auto';
      const p = this.video.play();
      if (p && p.catch) p.catch(() => {});
      this.classList.add('is-playing');
      this.toggle?.setAttribute('aria-label', window.rnStrings?.pauseVideo || 'Pause video');
    }

    pause() {
      this.video.pause();
      this.classList.remove('is-playing');
      this.toggle?.setAttribute('aria-label', window.rnStrings?.playVideo || 'Play video');
    }
  }

  customElements.get('rn-video') || customElements.define('rn-video', RnVideo);
})();
